/**
 * WebView 偵測與處理
 */

import { isTWAEnvironment } from './platformDetection';

export function isInWebView() {
  return checkUserAgent() || checkFeatures() || checkPlatformSpecific();
}

function checkUserAgent() {
  const ua = navigator.userAgent.toLowerCase();
  const indicators = [
    'wv',
    'webview',
    'line/',
    'fb_iab',
    'instagram',
    'miuibrowser',
    'weixin',
    'wxwork',
    'micromessenger',
  ];
  const hasMarker = indicators.some((i) => ua.includes(i));
  const isMobileWithoutBrowser =
    (ua.includes('android') && !ua.includes('chrome')) ||
    (ua.includes('iphone') && !ua.includes('safari'));
  return hasMarker || isMobileWithoutBrowser;
}

function checkFeatures() {
  const missing = [
    typeof navigator.share === 'undefined',
    typeof navigator.serviceWorker === 'undefined',
    typeof navigator.credentials === 'undefined',
  ];
  return missing.filter(Boolean).length >= 2;
}

function checkPlatformSpecific() {
  const hasAndroid =
    typeof window.AndroidInterface !== 'undefined' || typeof window.Android !== 'undefined';
  const hasIOS =
    typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers !== 'undefined';
  return hasAndroid || hasIOS;
}

export function showWebViewWarning() {
  if (isTWAEnvironment()) return;
  if (localStorage.getItem('webview_warning_dismissed')) return;
  openInSystemBrowser();
  localStorage.setItem('webview_warning_dismissed', 'true');
}

export function openInSystemBrowser() {
  const url = window.location.href;
  const ua = navigator.userAgent.toLowerCase();

  const w = window.open(url, '_system');
  setTimeout(() => {
    if (!w || w.closed || typeof w.closed === 'undefined') {
      if (ua.includes('android')) {
        window.location.href = `intent://${window.location.host}${window.location.pathname}${window.location.search}#Intent;scheme=${window.location.protocol.replace(':', '')};package=com.android.chrome;end`;
      } else if (ua.includes('iphone') || ua.includes('ipad')) {
        window.location.href = `x-web-search://?${url}`;
      }
    }
  }, 100);
}

export function hideGoogleLoginButtons() {
  if (isTWAEnvironment()) return;
  const selectors = [
    '.google-auth-button',
    '.hjjgo-social-btn.google',
    'button[onclick*="google"]',
    '[data-testid="google-login"]',
  ];
  selectors.forEach((sel) => {
    try {
      document.querySelectorAll(sel).forEach((el) => {
        el.style.display = 'none';
      });
    } catch (e) {
      // ignore
    }
  });
}
